'user strict';

const EMPTY_STRING = '';

const LOAD_METRIC_ANCILLARIES_MODULE_PER_PAGE = {
    'PAYMENT': 'PLUS_LOAD_ANCILLARIES_MODULE_PAYMENT',
    'CANX': 'PLUS_LOAD_ANCILLARIES_MODULE_CANX',
    'INSURANCE': 'PLUS_LOAD_ANCILLARIES_MODULE_INSURANCE',
    'FLEX': 'PLUS_LOAD_ANCILLARIES_MODULE_FLEX',
    'ADDITIONS': 'PLUS_LOAD_ANCILLARIES_MODULE_ADDITIONS',
    'SELECTION': 'PLUS_LOAD_ANCILLARIES_MODULE_SELECTION',
};

const ERROR_METRIC_ANCILLARIES_MODULE_PER_PAGE = {
    'PAYMENT': 'PLUS_ERROR_COUNT_ANCILLARIES_MODULE_PAYMENT',
    'CANX': 'PLUS_ERROR_COUNT_ANCILLARIES_MODULE_CANX',
    'INSURANCE': 'PLUS_ERROR_COUNT_ANCILLARIES_MODULE_INSURANCE',
    'FLEX': 'PLUS_ERROR_COUNT_ANCILLARIES_MODULE_FLEX',
    'ADDITIONS': 'PLUS_ERROR_COUNT_ANCILLARIES_MODULE_ADDITIONS',
    'SELECTION': 'PLUS_ERROR_COUNT_ANCILLARIES_MODULE_SELECTION',
};

const getLoadMetricKey = function(pageToTrack = '') {
    return Odigeo._.get(LOAD_METRIC_ANCILLARIES_MODULE_PER_PAGE, pageToTrack.toUpperCase(), EMPTY_STRING);
};

const getErrorMetricKey = function(pageToTrack = '') {
    return Odigeo._.get(ERROR_METRIC_ANCILLARIES_MODULE_PER_PAGE, pageToTrack.toUpperCase(), EMPTY_STRING);
};

module.exports = {
    LOAD_METRIC_ANCILLARIES_MODULE_PER_PAGE,
    ERROR_METRIC_ANCILLARIES_MODULE_PER_PAGE,
    getLoadMetricKey,
    getErrorMetricKey,
};
